import { siteInfo, topTags } from "@/mocks/gua";

export default function Header() {
  return (
    <header className="w-full border-b border-background-200">
      <div className="mx-auto max-w-6xl px-4 pb-6 pt-8 md:px-6 md:pb-8 md:pt-12">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="flex items-center gap-3">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-xl" />
              </span>
              <h1 className="text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
                色瓜网
              </h1>
            </div>
            <p className="mt-3 max-w-xl text-sm leading-6 text-foreground-600 md:text-base">
              看大瓜 · 追内幕 · 捋清每一条劲爆消息的来龙去脉。这里汇集近期网络热议的猛料与深度挖掘内容。
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            {topTags.map((t) => (
              <a
                key={t.id}
                href="#"
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-100 px-3.5 py-1.5 text-xs text-foreground-700 transition-colors hover:bg-accent-100 hover:text-accent-700"
              >
                <i className={t.icon} />
                {t.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
}